import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { IconInput } from '@alfa-bank/site-icon-input/icon-input';
import { Label } from '@alfa-bank/site-icon-input/label';

import type { TSearchBarDesktop, IDepsDesktop } from './models';
import { SearchBar as Component } from './search-bar';
import styles from './styles/desktop.css';

export const SearchBarDesktop = createWidget<IDepsDesktop, TSearchBarDesktop>({
    styles,
    IconInput,
    Label,
})(Component);
